import React, { createContext, useContext } from 'react';
import Dialog from '../components/Dialog';
import { useDialog } from '../hooks/useDialog';

interface DialogContextType {
  confirm: (question: string, actionType?: string) => Promise<boolean>;
}

const DialogContext = createContext<DialogContextType | undefined>(undefined);

export const useConfirmDialog = () => {
  const context = useContext(DialogContext);
  if (!context) {
    throw new Error('useConfirmDialog must be used within a DialogProvider');
  }
  return context;
};

interface DialogProviderProps {
  children: React.ReactNode;
  theme?: 'light' | 'dark';
}

export const DialogProvider: React.FC<DialogProviderProps> = ({ children, theme = 'light' }) => {
  const { confirm, dialogState, handleClose, handleConfirm } = useDialog();

  return (
    <DialogContext.Provider value={{ confirm }}>
      {children}
      <Dialog
        isOpen={dialogState.isOpen}
        onClose={handleClose}
        onConfirm={handleConfirm}
        question={dialogState.question}
        actionType={dialogState.actionType}
        theme={theme}
      />
    </DialogContext.Provider>
  );
};

export default DialogProvider; 